<template>
  <div id="footer">
    <div class="container">
      <!-- 상단: 서비스 이용약관, 개인정보처리방침 링크 -->
      <div class="top">
        <router-link :to="{ name: 'servicePolicy' }" class="terms">서비스 이용약관</router-link>
        <router-link :to="{ name: 'privacy' }" class="privacy">개인정보처리방침</router-link>
      </div>

      <!-- 회사 및 연락처 정보 -->
      <div class="info">
        <p class="title">(주)전남드래곤즈</p>
        <p class="num">
          사업자등록번호 : 416-81-10186
          <span>호스팅 제공자 : ㈜플랫폼엔</span>
        </p>
        <p>통신판매업 신고번호 : 제2005-전남광양-12-28호</p>
        <p>
          <span class="tel">대표전화 : 061)815-0114</span>
          <span>팩스 : 061)815-0119</span>
        </p>
        <p class="addr sm">
          사무국 주소 : 전남광주통합특별시 광양시 광포로 46 동광양농협하나로마트 3층 전남드래곤즈 프로축구단
        </p>
        <p class="sm">대표메일 : <a href="mailto:dragons@dragons.co.kr">dragons@dragons.co.kr</a></p>
      </div>

      <!-- SNS 링크 아이콘 -->
      <div class="sns">
        <a href="https://www.facebook.com/dragonsfc" target="_blank" rel="noopener">
          <img src="@/assets/img/icon/icon_facebook.png" alt="facebook" />
        </a>
        <a href="https://www.youtube.com/@JeonnamFC" target="_blank" rel="noopener">
          <img src="@/assets/img/icon/icon_youtube.png" alt="youtube" />
        </a>
        <a href="https://www.instagram.com/jeonnamdragons_fc/" target="_blank" rel="noopener">
          <img src="@/assets/img/icon/icon_instagram.png" alt="instagram" />
        </a>
        <a href="https://pf.kakao.com/_DmGvxb" target="_blank" rel="noopener">
          <img src="@/assets/img/icon/icon_kakaotalk.png" alt="kakaotalk" />
        </a>
      </div>

      <!-- 저작권 정보 -->
      <p class="copy">
        copyright ⓒ JEONNAM DRAGONS. All rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterView',
  data() {
    return {
      // 참고용으로 SNS 아이콘 데이터 하나만 포함되어 있으나 실제로는 템플릿에 직접 이미지 삽입됨
      snsIcon: [
        {
          name: 'facebook',
          imgSrc: '@assets/img/icon/icon_facebook.png',
        },
      ],
    };
  },
};
</script>
